var getClassNames = require('./lib/get-class-names').getClassNames;

module.exports = {
  getClassNames: getClassNames
};



//////////////////
// WEBPACK FOOTER
// ./~/dynamic-class-list/index.js
// module id = 46
// module chunks = 0